export default __webpack_public_path__ + "static/media/Leggings of Jagged Barbs.209b5808.jpg";